import React, { useEffect, useState } from "react";
import { withRouter } from 'react-router-dom';
import ErrorIcon from '@material-ui/icons/Error';
import CircularProgress from '@material-ui/core/CircularProgress';
import { jwt } from '../../common/jwtAuthentication';
import { genericApi, logOut } from '../../common/apiconfig';
import FormHoc from '../hoc/formHoc';
import { InputField, AutoOptions } from '../formElements';
import { Dropdowns } from '../../common/constants';
import { connect } from 'react-redux';
import * as constObj from '../../common/constants';
import { ErrorLables } from '../../common/lables';
import { funcDropdown, appConfig } from '../../common/constants'
import SignupImg from '../../../img/Signup3.png'
import { GoogleLogin } from 'react-google-login'
import FacebookLogin from 'react-facebook-login';
import PasswordStrengthChecker from '../../../globalcomponents/passwordstrengthchecker'
const UpdateContactProfile = (propsobj) => {
  let [apiError, setApiError] = useState(false);
  let [progress, setProgress] = useState(false);
  let [userExsits, setUserExsits] = useState("")
  let [provider, setProvider] = useState("")

  const hocObj = FormHoc(propsobj);

  const textProps = {
    ...hocObj,
    propsobj
  }

  const autoPropsToLang = {
    default: {
      value: 'English US',
      label: 'English US',
    },
    'options': Dropdowns.Languages,
    freeSolo: false,
    propsobj,
    keys: ['value']
  }

  const autoPropstorole = {
    ...autoPropsToLang,
    'options': Dropdowns.Contact_Role,
    default: null,
  }

  useEffect(() => {
    propsobj.UpdateFormField({ name: "username", value: "" })
    propsobj.UpdateFormField({ name: "password", value: "" })
    async function fetchData() {
      //not helpful
      localStorage.setItem("hideheaderitem", true)
      //////////////////
      let queryParam = new URLSearchParams(propsobj.location.search);
      let accessToken = queryParam.get('token');
      jwt.setCookie('jwtToken', accessToken, 1);
      await funcDropdown()
      // await roles()
      if (accessToken && accessToken.length) {
        //if(true){    
        jwt.setCookie('jwtToken', accessToken, 1);//update token

        let requestBody = `
                                 query {
                                    getTobeActivatedAccountUser {
                                              sponsorAccountUserId
                                                sponsorAccountId
                                                SponsorAccountName
                                                firstName
                                                middleName
                                                lastName
                                                email
                                                phone
                                                position
                                                role
                                                language
                                                portalAccessInd
                                                invitedBy
                                                invitedDate
                                                activated
                                                primaryContactInd
                                        }
                                    }
                                `;

        requestBody = JSON.stringify({ query: requestBody });
        setProgress(true);

        let res = await genericApi('getTobeActivatedAccountUser', requestBody);
        setProgress(false);

        //if token not validated allow user to get new token by showing link expired, click now to activate again
        if (!res) {
          //if (false) {
          console.log('Error 119 at profile js')
          //setApiError(true);
          // setTimeout(function () { setApiError(false) }, 1000 * 30);
        } else {
          let data = res.data.getTobeActivatedAccountUser;
          let resData = {
            fname: data.firstName,
            lname: data.lastName,
            mname: data.middleName,
            lang: data.language,
            roles: data.role,
            phone: data.phone,
            accountName: data.SponsorAccountName,
            email: data.email,
            sponsorAccountId: data.sponsorAccountUserId
          }
          let obj = {
            value: { ...resData }
          }
          propsobj.UpdateEntireForm(obj);
        }
      }
    }
    fetchData();
    return () => {
      jwt.setCookie('jwtToken', '', 0);
    }
  }, []);

  const formSubmit = async (event) => {
    event.preventDefault();
    let userExits
    let setGo
    let requestBody = {
      query: `query {
                      checkLoginIdExist(userId:"${propsobj.formValues.username}")
                    }`
    };
    setProgress(true);
    requestBody = JSON.stringify(requestBody);
    let res = await genericApi('checkLoginIdExist', requestBody);
    console.log(res, "checkloginid")
    setProgress(false);
    if (!res) {
      //setApiError(true);
      //setTimeout(function () { setApiError(false) }, 1000 * 30);
    } else {
      userExits = res.data.checkLoginIdExist
    }
    if (userExits) { setUserExsits(propsobj.formValues.username + " username already exits") }
    else {
      setGo = await hocObj.handleSubmit('updateAccountForm', event);
      setUserExsits('')
    }
    console.log(setGo, "setGo")

    if (setGo) {
      let form = propsobj.formValues;
      console.log(form, "form")
      // checking confirm password
      if (form.cpassword.length > 0 && form.password !== form.cpassword) {
        let obj = {
          name: 'cpassword',
          flag: true,
          text: "Password mismatch",
        }
        propsobj.updateErrorObj(obj);
        return;
      } else {
        let obj = {
          name: 'cpassword',
          flag: false,
          text: ''
        }
        propsobj.updateErrorObj(obj);
      }

      let requestBody = `
              mutation {
      updateUserLoginCredentials(
                      sponsorAccountUserId: "${form.sponsorAccountId}",
                      firstName: "${form.fname}", 
                      lastName :"${form.lname}",
                      email :"${form.email}",
                      language:"${form.lang}",
                      userId:"${form.username}",
                      password:"${form.password}",
                     ) {
                    code
                    type
                    message
                    attributes
                }
              }
            `;
      setProgress(true);
      requestBody = JSON.stringify({ query: requestBody });
      let res = await genericApi('updateUserLoginCredentials', requestBody);
      setProgress(false);
      if (!res) {
        console.log('Error on update profile');
        //setApiError(true);
        //setTimeout(function () { setApiError(false) }, 1000 * 30);
      } else {
        // alert('form updated, please login with new password!');
        //logOut();
        jwt.setCookie('jwtToken', '', 0);
        //http://54.153.61.70:9000/login
        // redirecting to site app
        var url = window.location.hostname
        window.location.replace(`${url}/login`);
      }
    }
  }

  const handleCancel = (event) => {
    event.preventDefault();
    propsobj.history.goBack();
  }

  const responseGoogle = async (response) => {
    console.log(response, "google");
    // setProgress(true);
    if (response) {
      propsobj.UpdateFormField({ name: "fname", value: response.profileObj.givenName })
      propsobj.UpdateFormField({ name: "lname", value: response.profileObj.familyName })
      propsobj.UpdateFormField({ name: "email", value: response.profileObj.email })
      setProvider("google")
    }
  }
  const responseFacebook = async (response) => {
    console.log(response);
    if (response) {
      propsobj.UpdateFormField({ name: "fname", value: response.name })
      propsobj.UpdateFormField({ name: "email", value: response.email })
      setProvider("facebook")
    }

  }
  return (
    <>
      {progress && <div className="fullScreen">
        <CircularProgress
          disableShrink
          className="progressCircle"
          value={90}
          size={100}
          thickness={1.5}
        />
      </div>}


      <div className="row" style={{ justifyContent: "center", alignItems: "center" }}>
        <div className="col-md-6">
          <form noValidate autoComplete="off" id="updateAccountForm" className="inputForm" onSubmit={formSubmit}>

            <div className="panel-primary-wrap">
              <div className="card">
                <div className="card-body">
                  <div className="card-page-header google">SIGNUP <span style={{ float: "right", marginTop: "9px" }}>
                    {/* <img src={Google} style={{ marginRight: "15px" }} />&nbsp;&nbsp;&nbsp; */}
                    <GoogleLogin
                      clientId="188642766391-dpunmqp1q1uohi1ri3o9r9dns6lhl7f4.apps.googleusercontent.com"
                      buttonText="Login"
                      onSuccess={responseGoogle}
                      // onFailure={responseGoogle}
                      cookiePolicy={'single_host_origin'}
                    />
                    <FacebookLogin
                      appId="2039973542812369"
                      // autoLoad={true}
                      size="small"
                      fields="name,email,picture"
                      // cssClass="my-facebook-button-class"
                      icon="fa-facebook"
                      textButton="Login"
                      // onClick={componentClicked}
                      callback={responseFacebook} />
                    {/* <img src={Facebook} />*/}
                  </span>
                  </div>
                  <div className="inputBox">

                    <InputField {...textProps} name="fname" label="First Name" must={'true'} type="text" />

                    <InputField {...textProps} name="lname" label="Last Name" must={'true'} type="text" />
                    <div style={{ position: "relative" }}>
                      <InputField {...textProps} name="username" label="User Name" must={'true'} type="text" />
                      <span style={{ color: "#f44336", fontSize: "12px", fontWeight: "400" }}>{userExsits}</span>
                    </div>
                    {/* <InputField {...textProps} name="accountName" label="Account Name" must={'true'} type="text" /> */}

                    {/* <AutoOptions {...autoPropstorole} name="roles" label="Roles" keyName='value' must={'true'} /> */}

                    <InputField {...textProps} name="email" label="Email" must={'true'} type="email" />

                    <InputField {...textProps} name="password" label="Password" must={'true'} type="password" />
                    {propsobj.formValues.password.length > 3 &&
                      <PasswordStrengthChecker chkpassword={propsobj.formValues.password} />
                    }
                    <InputField {...textProps} name="cpassword" label="Confirm Password" must={'true'} type="password" />

                    <AutoOptions {...autoPropsToLang} name="lang" label="Language" keyName='value' must={'true'} />
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-md-6">
                        <div className="panel-primary-wrap">
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-page-header">CONTACT INFORMATION</div>
                                    <div className="inputBox">
                                        <InputField {...textProps} name="phone" label="Phone" must={'true'} type="text" />
                                        <InputField {...textProps} name="email" label="Email" must={'true'} type="email" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
            <div className="buttonContainer col-12 ml-auto">
              <button type="submit" className="btn btn-primary-blue btn-rounded btn-small">Save</button>
              {/* <button className="btn btn-primary-grey btn-rounded btn-small" onClick={handleCancel}>CANCEL</button> */}
            </div>
          </form>
        </div>
        <div className="col-md-6" style={{ textAlign: "center" }}>
          {/* <div className="card">
            <div className="card-body"> */}
          <p><span style={{ fontSize: "25px", color: "#003680" }}>Hekma’s mission</span> is to deliver powerful real time AI driven insights for smarter and efficient ways to monitor clinical trial and healthcare ...
          </p>
          <img src={SignupImg} />
          {/* </div>
          </div> */}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    },
    UpdateEntireForm: (obj) => {
      return dispatch(
        {
          type: 'UpdateEntireForm',
          value: obj.value,
        }
      )
    },
    clearForm: () => {
      return dispatch(
        {
          type: 'ClearForm',
        }
      )
    },
    updateErrorObj: (obj) => {
      return dispatch(
        {
          type: 'updateErrorObj',
          flag: obj.flag,
          name: obj.name,
          text: obj.text
        }
      )
    },
    updateEntireErrorObj: (errobj, errtextobj) => {
      return dispatch(
        {
          type: 'updateEntireErrorObj',
          errobj: errobj,
          errtextobj: errtextobj,
        }
      )
    }

  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpdateContactProfile));
